
























import Vue from 'vue';

export default Vue.extend({
  props: {
    modalId: {
      type: String,
      required: true,
    },
    opened: {
      type: Boolean,
      required: true,
    },
    closeOnClickBackdrop: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    opened(isOpened) {
      if (isOpened) {
        this.$modal.push(this.modalId);
      } else {
        this.$modal.pop();
      }
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
});
